import React from 'react';
import { CheckCircle2, BookOpen, Calendar, HeartPulse, Shield } from 'lucide-react';
export function WhatYouGet() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-210">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-211">
        <h2 className="font-serif text-3xl md:text-4xl text-[#2D2A26] mb-12 text-center" data-id="element-212">
          Lo que recibes{' '}
          <span className="text-[#C4705A] text-2xl md:text-3xl block mt-2" data-id="element-213">
            (dentro del PDF interactivo)
          </span>
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-214">
          <div className="space-y-6" data-id="element-215">
            <div className="flex gap-4" data-id="element-216">
              <div className="bg-[#FFF4F0] p-2 rounded-lg h-fit" data-id="element-217">
                <ActivityIcon className="w-6 h-6 text-[#C4705A]" data-id="element-218" />
              </div>
              <div data-id="element-219">
                <h3 className="font-bold text-[#2D2A26] text-lg" data-id="element-220">
                  El Test 60s
                </h3>
                <p className="text-[#2D2A26]/70 text-sm" data-id="element-221">
                  Para identificar tu zona principal de dolor (A, B o C) y no
                  perder tiempo en ejercicios que no necesitas.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-222">
              <div className="bg-[#FFF4F0] p-2 rounded-lg h-fit" data-id="element-223">
                <BookOpen className="w-6 h-6 text-[#C4705A]" data-id="element-224" />
              </div>
              <div data-id="element-225">
                <h3 className="font-bold text-[#2D2A26] text-lg" data-id="element-226">
                  Rutinas completas de 7 min
                </h3>
                <p className="text-[#2D2A26]/70 text-sm" data-id="element-227">
                  Guías paso a paso para tus momentos de Mañana, Pausa y Noche.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-228">
              <div className="bg-[#FFF4F0] p-2 rounded-lg h-fit" data-id="element-229">
                <Shield className="w-6 h-6 text-[#C4705A]" data-id="element-230" />
              </div>
              <div data-id="element-231">
                <h3 className="font-bold text-[#2D2A26] text-lg" data-id="element-232">
                  Protocolos por zona
                </h3>
                <p className="text-[#2D2A26]/70 text-sm" data-id="element-233">
                  Específicos para Cuello-Hombros, Espalda Alta o Espalda
                  Baja-Cadera.
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-6" data-id="element-234">
            <div className="flex gap-4" data-id="element-235">
              <div className="bg-[#FFF4F0] p-2 rounded-lg h-fit" data-id="element-236">
                <Calendar className="w-6 h-6 text-[#C4705A]" data-id="element-237" />
              </div>
              <div data-id="element-238">
                <h3 className="font-bold text-[#2D2A26] text-lg" data-id="element-239">
                  Plan de 14 días
                </h3>
                <p className="text-[#2D2A26]/70 text-sm" data-id="element-240">
                  Un calendario simple y visual para seguir tu progreso sin
                  agobiarte.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-241">
              <div className="bg-[#FFF4F0] p-2 rounded-lg h-fit" data-id="element-242">
                <HeartPulse className="w-6 h-6 text-[#C4705A]" data-id="element-243" />
              </div>
              <div data-id="element-244">
                <h3 className="font-bold text-[#2D2A26] text-lg" data-id="element-245">
                  Protocolo de "Día Malo"
                </h3>
                <p className="text-[#2D2A26]/70 text-sm" data-id="element-246">
                  Una rutina de emergencia de 3 minutos para cuando el dolor es
                  intenso o no tienes tiempo.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-247">
              <div className="bg-[#FFF4F0] p-2 rounded-lg h-fit" data-id="element-248">
                <CheckCircle2 className="w-6 h-6 text-[#C4705A]" data-id="element-249" />
              </div>
              <div data-id="element-250">
                <h3 className="font-bold text-[#2D2A26] text-lg" data-id="element-251">
                  Semana Mínima Viable
                </h3>
                <p className="text-[#2D2A26]/70 text-sm" data-id="element-252">
                  Cómo mantener tus resultados a largo plazo sin obsesión.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function ActivityIcon(props: any) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-253">
      <path d="M22 12h-4l-3 9L9 3l-3 9H2" data-id="element-254" />
    </svg>;
}